import { useQuery } from '@tanstack/react-query';
import { financeApi } from '@/lib/api/finance';
import { useI18n } from '@/i18n';

const yuan = (cents: number) =>
  (cents / 100).toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' });

export function ExpensesTab() {
  const { t } = useI18n();
  const { data, isLoading } = useQuery({
    queryKey: ['finance-expenses'],
    queryFn: financeApi.getExpenses,
  });
  if (isLoading || !data) {
    return <div className="p-6 text-gray-500">{t('common.loading')}</div>;
  }

  return (
    <div className="bg-white rounded-lg border overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 bg-gray-50">
            <th className="p-2">{t('financePage.date')}</th>
            <th className="p-2">{t('financePage.category')}</th>
            <th className="p-2 text-right">{t('financePage.amount')}</th>
            <th className="p-2">{t('financePage.account')}</th>
            <th className="p-2">{t('financePage.note')}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((e, i) => (
            <tr key={i} className="border-t">
              <td className="p-2 whitespace-nowrap">{e.date}</td>
              <td className="p-2">{e.category}</td>
              <td className="p-2 text-right font-medium">{yuan(e.amount_cny_cents)}</td>
              <td className="p-2">{e.account ?? '—'}</td>
              <td className="p-2 text-gray-500">
                {e.vendor_url ? (
                  <a
                    href={e.vendor_url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    {e.description ?? e.vendor_url}
                  </a>
                ) : (
                  e.description ?? '—'
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
